import type { TaskRecurrence } from "./types";

export const RECURRENCE_OPTIONS: { value: TaskRecurrence; label: string }[] = [
	{ value: "DAILY", label: "Har kuni" },
	{ value: "WEEKLY", label: "Har hafta" },
	{ value: "MONTHLY", label: "Har oy" },
];

export const RECURRENCE_LABELS: Record<TaskRecurrence, string> = {
	DAILY: "Har kuni",
	WEEKLY: "Har hafta",
	MONTHLY: "Har oy",
};

export const RECURRENCE_COLORS: Record<TaskRecurrence, string> = {
	DAILY: "blue",
	WEEKLY: "geekblue",
	MONTHLY: "purple",
};

/**
 * Weekday options — value follows JS `Date.getDay()`: 0 = Sunday ... 6 = Saturday.
 * Must match the backend cron generator (tasks-cron.ts).
 */
export const WEEKDAY_OPTIONS: { value: number; label: string }[] = [
	{ value: 1, label: "Dushanba" },
	{ value: 2, label: "Seshanba" },
	{ value: 3, label: "Chorshanba" },
	{ value: 4, label: "Payshanba" },
	{ value: 5, label: "Juma" },
	{ value: 6, label: "Shanba" },
	{ value: 0, label: "Yakshanba" },
];

export const WEEKDAY_LABELS: Record<number, string> = {
	0: "Yakshanba",
	1: "Dushanba",
	2: "Seshanba",
	3: "Chorshanba",
	4: "Payshanba",
	5: "Juma",
	6: "Shanba",
};
